import React, { useEffect, useRef, useState } from 'react';
import { DateRange as ReactDateRange } from 'react-date-range';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import { useField } from '@unform/core';
import { pt } from 'date-fns/locale';
import moment from 'moment';

import useOnClick from '~/pages/utils/useOnClick';
import colors from '~/styles/colors';

import { Container, ErrorSpan } from './styles';

type DateRangeProps = {
  name: string;
  defaultStartDate?: Date | null;
  defaultEndDate?: Date | null;
  hideCalendar?: boolean;
};

const DateRange: React.FC<DateRangeProps> = ({
  name,
  defaultStartDate,
  defaultEndDate,
  hideCalendar,
}) => {
  const [colorSet, setColorSet] = useState<string[]>(['transparent']);
  const [focus, setFocus] = useState<boolean>(false);
  const [state, setState] = useState<any>([
    {
      startDate: defaultStartDate ?? null,
      endDate: defaultEndDate ?? null,
      key: 'selection',
    },
  ]);

  const datePickerRef = useRef(null);
  const { fieldName, registerField, error } = useField(name);
  useEffect(() => {
    registerField({
      name: fieldName,
      // eslint-disable-next-line consistent-return
      getValue: () => {
        if (state[0].startDate !== null || state[0].endDate !== null) {
          return [
            moment(new Date(state[0].startDate)).startOf('day').toDate(),
            moment(new Date(state[0].endDate)).endOf('day').toDate(),
          ];
        }
      },
    });
  }, [fieldName, registerField, state]);

  useEffect(() => {
    if (state && (state[0].startDate || state[0].endDate)) {
      setColorSet([colors.primary]);
    } else {
      setColorSet(['transparent']);
    }
  }, [state]);

  useOnClick(
    datePickerRef,
    () => setFocus(false),
    () => setFocus(true),
  );

  return (
    <Container
      disableRangeSelect={colorSet[0] === 'transparent'}
      hideCalendar={hideCalendar && focus === false}
      ref={datePickerRef}
    >
      <ReactDateRange
        showMonthAndYearPickers={false}
        dateDisplayFormat="dd/MM/yyyy"
        startDatePlaceholder="Início"
        endDatePlaceholder="Fim"
        editableDateInputs
        onChange={(item) => setState([item.selection])}
        moveRangeOnFirstSelection={false}
        ranges={state}
        rangeColors={colorSet}
        locale={pt}
      />
      {error && <ErrorSpan>error</ErrorSpan>}
    </Container>
  );
};

export default DateRange;
